import resolveQueryStringToRecipient from './resolveQueryStringToRecipient';
import setForceResolveState from './setForceResolveState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { action } from 'satcheljs/lib/legacy';

// Using a "global" timer for this case since we want to kill any search within the timeout scope.
let currentTimeout = null;
const DEBOUNCE_TIMEOUT = 150;

let resolveQueryStringDebounce = (
    recipientWell: RecipientWellWithFindControlViewState,
    isLastCharSemiColon: boolean
) => () => {
    currentTimeout = null;
    resolveQueryStringToRecipient(recipientWell, isLastCharSemiColon /**shouldDirectlyResolve */);
};

export default action('updateFindControlQueryString')(function updateFindControlQueryString(
    recipientWell: RecipientWellWithFindControlViewState,
    inputText: string
) {
    if (currentTimeout) {
        clearTimeout(currentTimeout);
    }

    // If the user is typing, we should reset forceResolve state, just in case.
    setForceResolveState(recipientWell, false /* inForceResolve */);
    // Set the first result to highlighted, if nothing else is.
    if (recipientWell.findResultHightlightIndex == -1) {
        recipientWell.findResultHightlightIndex = 0;
    }
    // Check if last char is semi-colon and if so, remove it from query string.
    let lastCharIndex = inputText.length - 1;
    let lastChar = inputText[lastCharIndex];
    let isLastCharAKnownDelimiter = lastChar == ';' || lastChar == ',';
    if (isLastCharAKnownDelimiter) {
        inputText = inputText.substring(0, lastCharIndex);
    }
    recipientWell.queryString = inputText;
    // Directly resolve if user explicitly typed semi-colon at the end.
    currentTimeout = setTimeout(
        resolveQueryStringDebounce(
            recipientWell,
            isLastCharAKnownDelimiter /**shouldDirectlyResolve */
        ),
        DEBOUNCE_TIMEOUT
    );
});
